import { useRef } from "react";

export function useFactory<T>(factory: () => T): T {
  const ref = useRef<{ value: T }>();
  ref.current = ref.current ?? { value: factory() };
  return ref.current.value;
}
